import {NextPage} from 'next';
import {useRouter} from 'next/router';

import {useMultipassUrl} from '#apollo/query/useMultipassUrl';
import {Button} from '#component/base';
import {EventType, useAnalytics, UserActionEvent} from '#component/provider/AnalyticsProvider';

const STORE_URL = process.env.NEXT_PUBLIC_STORE_URL;

export interface BuyIndividualTestKitProps {
  variantId: string;
}

const BuyIndividualTestKit: NextPage<BuyIndividualTestKitProps> = ({variantId}) => {
  const {query, replace} = useRouter();
  const {getMultipassUrl} = useMultipassUrl();
  const {path, ...params} = query;
  const {track} = useAnalytics();

  const handleBuyClick = async () => {
    const specificPath = `cart/${variantId}:1`;
    const url = await getMultipassUrl(`${STORE_URL}/${specificPath}`, {...params});

    track<UserActionEvent>({
      evtName: EventType.UserAction,
      actionName: 'Manage My Plan - Buy Test',
    });

    replace(url);
  };

  return (
    <div>
      <Button onClick={handleBuyClick} as="a" variant="secondary">
        Buy
      </Button>
    </div>
  );
};

export default BuyIndividualTestKit;
